// ✅ 設定 Cookie
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
}

// ✅ 取得 Cookie
function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : "";
}

// ✅ 允許的分銷商清單
const allowedDistributors = [
  "millie", "julia", "Yu", "kol", "ikol", 
  "lisa", "Laura", "xinxincuisine", 
  "CookWithHana", "yurakumama"
];

// ✅ 讀取 Cookie
let distributor = getCookie("distributor");

// 如果不在允許清單，設為預設值
if (!allowedDistributors.includes(distributor)) {
  location.href = "/";
  document.write('<meta http-equiv="refresh" content="0;url=https://www.sealvax.com/">');
  //distributor = "yurakumama";
  //setCookie("distributor", distributor, 1);
}

// ✅ 批量隱藏元素
[".tier-1", ".menu", ".nav-search"].forEach(selector => {
  const el = document.querySelector(selector);
  if (el) el.style.display = "none";
});